import Vue from 'vue';
import VueRouter, { NavigationGuard, } from 'vue-router';
import { multiGuard, } from '~/utils/vue-router-multiguard';
import Index from './pages/index.vue';
import { Store, } from './store';

Vue.use(VueRouter);

const prefix = '/submit-meter-read';
const RequiresUserDetails: NavigationGuard = (to, _from, next) => {
	if (to.path === prefix) {
		next();
		return;
	}

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasExistingUserDetails) {
		next('/');
		return;
	}

	next();
};

const RequiresMeterDetails: NavigationGuard = (_to, _from, next) => {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasExistingMeterDetails) {
		next('/');
		return;
	}

	next();
};

const RequiresMeterReading: NavigationGuard = (_to, _from, next) => {
	if (!Store.state.currentMeterReading) {
		return next('/your-reading');
	}

	next();
};

export const Router = new VueRouter({
	base: prefix,
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0, };
	},
	routes: [
		{
			path: '/',
			component: {
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				render: (c: any) => c('router-view'),
			},
			children: [
				{ path: `your-details`, component: () => import('./pages/your-details.vue').then((m) => m.default), },
				{ path: `check-details`, component: () => import('./pages/check-details.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMeterDetails,]), },
				{ path: `your-reading`, component: () => import('./pages/your-reading.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMeterDetails,]), },
				{ path: `confirm-reading`, component: () => import('./pages/confirm-reading.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMeterDetails, RequiresMeterReading,]), },
				{ path: `success`, component: () => import('./pages/meter-read-success.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMeterDetails,]), },
				{ path: `successful`, component: () => import('./pages/meter-read-success.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMeterDetails,]), },
				{ path: `pending-read`, component: () => import('./pages/meter-read-pending.vue').then((m) => m.default), beforeEnter: multiGuard([RequiresUserDetails, RequiresMeterDetails,]), },
				{ path: `meter-upgrade`, component: () => import('./pages/meter-upgrade.vue').then((m) => m.default), },
				{ path: ``, component: Index, },
			],
		},
	],
});

Router.afterEach((to) => {
	Store.commit.setActiveAlert(to.fullPath);
});
